(() => {
  if (window.__oazarScrollingCardsReady) {
    window.__oazarScrollingCardsRefresh?.();
    return;
  }
  window.__oazarScrollingCardsReady = true;

  const roots = new Set();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  let frame = 0;

  function setHeading(root, index) {
    const headings = [...root.querySelectorAll('[data-osc-heading]')];
    if (!headings.length) return;
    const active = Math.min(headings.length - 1, Math.max(0, index));
    headings.forEach((heading, i) => {
      heading.classList.toggle('is-active', i === active);
      heading.classList.toggle('is-before', i < active);
      heading.setAttribute('aria-hidden', i === active ? 'false' : 'true');
    });
  }

  function update() {
    frame = 0;
    for (const root of roots) {
      if (!root.isConnected) {
        roots.delete(root);
        continue;
      }
      const cards = root.querySelector('[data-osc-cards]');
      const items = cards?.querySelectorAll('.osc__card');
      const headings = root.querySelectorAll('[data-osc-heading]');
      const progressBar = root.querySelector('[data-osc-progress]');
      if (!items?.length) continue;

      if (mobile.matches || reduced.matches) {
        root.style.removeProperty('--osc-y');
        root.style.removeProperty('--osc-copy-y');
        if (mobile.matches) {
          const step = items[0].getBoundingClientRect().width + 12;
          const cardIndex = Math.round(cards.scrollLeft / Math.max(step, 1));
          setHeading(root, Math.floor(cardIndex * headings.length / items.length));
          if (progressBar) progressBar.style.transform = `scaleX(${Math.min(1, (cardIndex + 1) / items.length)})`;
        } else {
          setHeading(root, 0);
          if (progressBar) progressBar.style.transform = 'scaleX(1)';
        }
        continue;
      }

      const scene = root.querySelector('.osc__scene');
      const distance = Math.max(1, root.offsetHeight - scene.offsetHeight);
      const progress = Math.min(1, Math.max(0, (80 - root.getBoundingClientRect().top) / distance));
      const last = items[items.length - 1];
      const end = Math.max(0, last.offsetTop + last.offsetHeight - scene.offsetHeight + 70);
      root.style.setProperty('--osc-y', `${(-progress * end).toFixed(1)}px`);
      root.style.setProperty('--osc-copy-y', `${(-progress * 320).toFixed(1)}px`);
      setHeading(root, Math.floor(progress * headings.length));
      if (progressBar && headings.length) progressBar.style.transform = `scaleX(${Math.min(1, 1 / headings.length + progress * (1 - 1 / headings.length))})`;
    }
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function refresh() {
    document.querySelectorAll('[data-osc]').forEach(root => {
      if (roots.has(root)) return;
      roots.add(root);
      const cards = root.querySelector('[data-osc-cards]');
      cards?.addEventListener('scroll', schedule, { passive: true });
      const navigate = direction => {
        if (mobile.matches) return;
        const headings = root.querySelectorAll('[data-osc-heading]');
        if (!headings.length) return;
        const scene = root.querySelector('.osc__scene');
        const distance = Math.max(1, root.offsetHeight - scene.offsetHeight);
        const progress = Math.min(1, Math.max(0, (80 - root.getBoundingClientRect().top) / distance));
        const current = Math.min(headings.length - 1, Math.floor(progress * headings.length));
        const target = Math.min(headings.length - 1, Math.max(0, current + direction));
        const sectionTop = window.scrollY + root.getBoundingClientRect().top;
        window.scrollTo({ top: sectionTop - 80 + distance * (target / headings.length + 0.02), behavior: reduced.matches ? 'auto' : 'smooth' });
      };
      root.querySelector('[data-osc-prev]')?.addEventListener('click', () => navigate(-1));
      root.querySelector('[data-osc-next]')?.addEventListener('click', () => navigate(1));
      root.querySelector('[data-osc-mobile-prev]')?.addEventListener('click', () => {
        const card = cards.querySelector('.osc__card');
        cards.scrollBy({ left: -(card.getBoundingClientRect().width + 12), behavior: reduced.matches ? 'auto' : 'smooth' });
      });
      root.querySelector('[data-osc-mobile-next]')?.addEventListener('click', () => {
        const card = cards.querySelector('.osc__card');
        cards.scrollBy({ left: card.getBoundingClientRect().width + 12, behavior: reduced.matches ? 'auto' : 'smooth' });
      });
    });
    schedule();
  }

  window.__oazarScrollingCardsRefresh = refresh;
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
